// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Three columns side by side */
.team
{
  width: 100%;
  margin-top: 5%;
    /* background-image: url(teambg.jpg);
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-blend-mode: darken; */
    background-image: transparent;
}
.container{
  margin-inline-start: 21vw;
}
.teamtitle{
  padding-top: 5%;
  padding-bottom: 10%;
  text-shadow: 0 0 50px rgb(156, 52, 11);
  font-family: "Zen Dots";
  width: 100%;
  font-size: 10vw;
  text-align: center;
  color:white;
}
.trow{
  width: 95vw;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 8%;
}
.column {
    float: center;
    width: 24vw;
    margin-bottom: 16px;
    padding: 0 4vw;
    margin-left: 2vw;
  }
  .columnthin {
    float: center;
    width: 19vw;
    margin-bottom: 16px;
    padding: 0 0.5vw;
  }
  
  .xtra{
    margin-left: 1%;
    margin-right: 1%;
    content-visibility: hidden;
    opacity: 0;
    transition: all 1000ms ease-in-out;
  }
  .xtra p{
    margin-bottom: 0;
    font-size:'1.0vw'
  }
  /* .xtra:hover{
    color: bisque;
    font-size: large;
  } */
  /* Add some shadows to create a card effect */
  .memcard {
    /* box-shadow: 0 2px 4px 0 rgba(147, 9, 138, 0.2); */
    background: white;
    transition: 1.0s;
    width: 100%;
    border-radius: 50px;
    text-align: center;
    color: black;
    padding-bottom: 2%;
  }
  .memcard p{
    font-size: 140%;
  }
  #arr {
    visibility: visible;
  }

  .infocont:hover + .xtra{
    z-index: 100;
    content-visibility: visible;
    color: black;
    opacity: 1;
    
  }
  .exeinfocont:hover + .xtra{
    z-index: 100;
    content-visibility: visible;
    color: black;
    opacity: 1;
    
  }
  /* .contact{
    content-visibility: hidden;
  }
  .infocont:hover+.contact{
    content-visibility: visible;
  } */
  .memcard:hover{
    z-index: 30;
    transform: translate3D(0,-1px,0) scale(1.1);
    /* background-image: url(cardbg.gif); */
    /* background-image: linear-gradient(to bottom left, rgb(0, 0, 0), rgb(142, 40, 40)); */
    color:orangered;
    border-radius: 20px;
    
  }
  
  /* Some left and right padding inside the container */
  .infocont {
    width:100%;
    height: 10vh;
    font-size:1.3vw;
    font-family: 'AudioWide';
    justify-content:'center';
    line-height: 2vh;
    padding-top: 7%;
  }
  .exeinfocont{
    width:100%;
    min-height: 5vh;
    font-size:1.2vw;
    font-family: 'AudioWide';
    display: flex;
    align-items: center;
    vertical-align: middle;
    justify-content: center;
    padding-top: 2%;
  }

  .feedback {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -40px;
    margin-bottom: 30px;
}

.feedback-button {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    padding: 12px 25px;
    font-size: 18px;
    font-weight: bold;
    color: black;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    text-transform: uppercase;
}

.feedback-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

  /* Display the columns below each other instead of side by side on small screens */
  @media screen and (max-width: 650px) {
    .feedback {
      margin-top: 0;
      width: 120%;
  }
    .container {
      display: flex;
      margin-left: 10vw;
      width: 100%;
      padding: 0;
      /* margin: auto; */
    }
    .team{
      width: 80vw;
    }
    .column {
      float: right;
      width: 40vw;
      margin-bottom: 16px;
      padding: 0 4vw;
      margin-left: 2vw;
    }
    .trow{
      width: 100vw;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: center;
    }
    .infocont {
      width:100%;
      font-size:1.8vw;
      text-wrap: wrap;
      line-height: 3vw;
      font-family: 'AudioWide';
      justify-content:'center';
      padding-top: 15%;
      padding-bottom: 0vw;
    }
    .exeinfocont{
      width:100%;
      font-size:1.4vw;
      font-family: 'AudioWide';
      /* justify-content:center; */
      vertical-align: middle;
      height: 40px;
      padding-top: 20%;
    }
    .columnthin {
      float: center;
      width: 29vw;
      margin-bottom: 16px;
      padding: 0 2vw;
    }
    .memcard{
      border-radius: 10%;
    }
    .memcard p{
      font-size: 250%;
    }
    .xtra p{
      font-size:3vw
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/team.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;;EAEE,WAAW;EACX,cAAc;IACZ;;;;;oCAKgC;IAChC,6BAA6B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;IACT,YAAY;IACZ,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,UAAU;IAKV,kCAAkC;EACpC;EACA;IACE,gBAAgB;IAChB;EACF;EACA;;;KAGG;EACH,6CAA6C;EAC7C;IACE,oDAAoD;IACpD,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,UAAU;;EAEZ;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,UAAU;;EAEZ;EACA;;;;;KAKG;EACH;IACE,WAAW;IACX,2CAA2C;IAC3C,uCAAuC;IACvC,uFAAuF;IACvF,eAAe;IACf,mBAAmB;;EAErB;;EAEA,qDAAqD;EACrD;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,yCAAyC;AAC7C;;EAEE,kFAAkF;EAClF;IACE;MACE,aAAa;MACb,WAAW;EACf;IACE;MACE,aAAa;MACb,iBAAiB;MACjB,WAAW;MACX,UAAU;MACV,kBAAkB;IACpB;IACA;MACE,WAAW;IACb;IACA;MACE,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,YAAY;QACV,YAAY;QACZ,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,uBAAuB;IAC3B;IACA;MACE,UAAU;MACV,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,wBAAwB;MACxB,wBAAwB;MACxB,gBAAgB;MAChB,mBAAmB;IACrB;IACA;MACE,UAAU;MACV,eAAe;MACf,wBAAwB;MACxB,4BAA4B;MAC5B,sBAAsB;MACtB,YAAY;MACZ,gBAAgB;IAClB;IACA;MACE,aAAa;MACb,WAAW;MACX,mBAAmB;MACnB,cAAc;IAChB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;IACA;MACE;IACF;EACF","sourcesContent":["/* Three columns side by side */\n.team\n{\n  width: 100%;\n  margin-top: 5%;\n    /* background-image: url(teambg.jpg);\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-blend-mode: darken; */\n    background-image: transparent;\n}\n.container{\n  margin-inline-start: 21vw;\n}\n.teamtitle{\n  padding-top: 5%;\n  padding-bottom: 10%;\n  text-shadow: 0 0 50px rgb(156, 52, 11);\n  font-family: \"Zen Dots\";\n  width: 100%;\n  font-size: 10vw;\n  text-align: center;\n  color:white;\n}\n.trow{\n  width: 95vw;\n    margin: auto;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding-bottom: 8%;\n}\n.column {\n    float: center;\n    width: 24vw;\n    margin-bottom: 16px;\n    padding: 0 4vw;\n    margin-left: 2vw;\n  }\n  .columnthin {\n    float: center;\n    width: 19vw;\n    margin-bottom: 16px;\n    padding: 0 0.5vw;\n  }\n  \n  .xtra{\n    margin-left: 1%;\n    margin-right: 1%;\n    content-visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 1000ms ease-in-out;\n    -moz-transition: all 1000ms ease-in-out;\n    -ms-transition: all 1000ms ease-in-out;\n    -o-transition: all 1000ms ease-in-out;\n    transition: all 1000ms ease-in-out;\n  }\n  .xtra p{\n    margin-bottom: 0;\n    font-size:'1.0vw'\n  }\n  /* .xtra:hover{\n    color: bisque;\n    font-size: large;\n  } */\n  /* Add some shadows to create a card effect */\n  .memcard {\n    /* box-shadow: 0 2px 4px 0 rgba(147, 9, 138, 0.2); */\n    background: white;\n    transition: 1.0s;\n    width: 100%;\n    border-radius: 50px;\n    text-align: center;\n    color: black;\n    padding-bottom: 2%;\n  }\n  .memcard p{\n    font-size: 140%;\n  }\n  #arr {\n    visibility: visible;\n  }\n\n  .infocont:hover + .xtra{\n    z-index: 100;\n    content-visibility: visible;\n    color: black;\n    opacity: 1;\n    \n  }\n  .exeinfocont:hover + .xtra{\n    z-index: 100;\n    content-visibility: visible;\n    color: black;\n    opacity: 1;\n    \n  }\n  /* .contact{\n    content-visibility: hidden;\n  }\n  .infocont:hover+.contact{\n    content-visibility: visible;\n  } */\n  .memcard:hover{\n    z-index: 30;\n    transform: translate3D(0,-1px,0) scale(1.1);\n    /* background-image: url(cardbg.gif); */\n    /* background-image: linear-gradient(to bottom left, rgb(0, 0, 0), rgb(142, 40, 40)); */\n    color:orangered;\n    border-radius: 20px;\n    \n  }\n  \n  /* Some left and right padding inside the container */\n  .infocont {\n    width:100%;\n    height: 10vh;\n    font-size:1.3vw;\n    font-family: 'AudioWide';\n    justify-content:'center';\n    line-height: 2vh;\n    padding-top: 7%;\n  }\n  .exeinfocont{\n    width:100%;\n    min-height: 5vh;\n    font-size:1.2vw;\n    font-family: 'AudioWide';\n    display: flex;\n    align-items: center;\n    vertical-align: middle;\n    justify-content: center;\n    padding-top: 2%;\n  }\n\n  .feedback {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: -40px;\n    margin-bottom: 30px;\n}\n\n.feedback-button {\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    padding: 12px 25px;\n    font-size: 18px;\n    font-weight: bold;\n    color: black;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n    text-transform: uppercase;\n}\n\n.feedback-button:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: scale(1.1);\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);\n}\n\n  /* Display the columns below each other instead of side by side on small screens */\n  @media screen and (max-width: 650px) {\n    .feedback {\n      margin-top: 0;\n      width: 120%;\n  }\n    .container {\n      display: flex;\n      margin-left: 10vw;\n      width: 100%;\n      padding: 0;\n      /* margin: auto; */\n    }\n    .team{\n      width: 80vw;\n    }\n    .column {\n      float: right;\n      width: 40vw;\n      margin-bottom: 16px;\n      padding: 0 4vw;\n      margin-left: 2vw;\n    }\n    .trow{\n      width: 100vw;\n        margin: auto;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: flex-start;\n        justify-content: center;\n    }\n    .infocont {\n      width:100%;\n      font-size:1.8vw;\n      text-wrap: wrap;\n      line-height: 3vw;\n      font-family: 'AudioWide';\n      justify-content:'center';\n      padding-top: 15%;\n      padding-bottom: 0vw;\n    }\n    .exeinfocont{\n      width:100%;\n      font-size:1.4vw;\n      font-family: 'AudioWide';\n      /* justify-content:center; */\n      vertical-align: middle;\n      height: 40px;\n      padding-top: 20%;\n    }\n    .columnthin {\n      float: center;\n      width: 29vw;\n      margin-bottom: 16px;\n      padding: 0 2vw;\n    }\n    .memcard{\n      border-radius: 10%;\n    }\n    .memcard p{\n      font-size: 250%;\n    }\n    .xtra p{\n      font-size:3vw\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
